import { isEmptyValue } from '@/utils/judgment';
import NP from 'number-precision';
import { v4 as uuidv4 } from 'uuid';
import { queryPurchaseDirectory, viewPurchaseDetail } from '../services/index';

export default {
  namespace: 'purchaseDeclare',
  state: {
    purchaseDeclareDetail: {},
    purchaseDirectory: [],
  },
  effects: {
    *viewDetail({ payload }, { call, put }) {
      const result = yield call(viewPurchaseDetail, payload);
      // 如果有数据，给每条数据添加indexNo属性，用于配合敏感词检测，生成唯一标识
      const temp = {
        ...result,
        purchaseCollectItemROList: result?.purchaseCollectItemROList?.map((item, index) => {
          return {
            ...item,
            indexNo: item?.indexNo || item?.purchaseCollectItemCode || uuidv4(),
          };
        }),
      };
      yield put({
        type: 'update',
        payload: {
          purchaseDeclareDetail: temp,
        },
      });
      return temp;
    },
    *queryPurchaseDirectory({ payload }, { call, put }) {
      const result = yield call(queryPurchaseDirectory, payload);
      yield put({
        type: 'update',
        payload: {
          purchaseDirectory: result,
        },
      });
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    changeDetail(state, { payload }) {
      if (payload.addedItem !== undefined) {
        // 添加
        state.purchaseDeclareDetail.purchaseCollectItemROList.push(payload.addedItem);
      } else if (payload.editedItem !== undefined) {
        // 编辑
        if (isEmptyValue(payload.rowDetail.purchaseCollectItemCode)) {
          // 编辑的是刚添加的，还没插入到数据库中数据
          state.purchaseDeclareDetail.purchaseCollectItemROList[
            payload.rowDetail.currentSerialNumber
          ] = payload.editedItem;
        } else {
          // 编辑的是已插入到数据库中的数据
          state.purchaseDeclareDetail.purchaseCollectItemROList[
            payload.rowDetail.currentSerialNumber
          ] = {
            purchaseCollectItemCode: payload.rowDetail.purchaseCollectItemCode,
            ...payload.editedItem,
          };
        }
      } else if (payload.deletedItem !== undefined) {
        // 删除
        state.purchaseDeclareDetail.purchaseCollectItemROList.splice(
          payload.deletedItem.currentSerialNumber,
          1,
        );
      }

      state.purchaseDeclareDetail.totalAmount = 0;
      for (const item of state.purchaseDeclareDetail.purchaseCollectItemROList) {
        state.purchaseDeclareDetail.totalAmount = NP.plus(
          state.purchaseDeclareDetail?.totalAmount || 0,
          item.totalPrice || 0,
        );
      }
      return {
        ...state,
      };
    },
  },
};
